export default {
    variantCountMatching: [3, 5],
    variantCountPaintBoxes: [3, 6],
    variantCountPicture: [5, 6],
    variantCountQuestion: [3, 4],
    variantCountManyAnsQuestion: [[3, 1], [5, 1]],
    rightAnsQuestion: [1, 1],
}